import cn from "classnames";
import { useEffect, useMemo, useState } from "react";
import { ChevronDown as ChevronDownIcon } from "@rshbintech.dboul/icons";
import { Text } from "../text";
import { AccordionProps } from "./types";
import styles from "./styles.module.scss";

export const Accordion = ({
  title,
  expanded,
  children,
  className,
  size = "large",
  weight = "regular",
  iconPosition = "right",
  dataTestId = "accordion",
  onClick,
}: AccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const handleClick = () => {
    setIsExpanded((isExpanded) => !isExpanded);
    onClick?.();
  };

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const titleContent = useMemo(
    () =>
      typeof title === "string" ? (
        <Text size={size} weight={weight}>
          {title}
        </Text>
      ) : (
        title
      ),
    [title, size, weight]
  );

  return (
    <div
      className={cn(
        styles.accordion,
        styles[iconPosition],
        { [styles.expanded]: isExpanded },
        className
      )}
      data-test-id={dataTestId}
    >
      <button
        type="button"
        className={styles.button}
        data-test-id={`${dataTestId}-button`}
        onClick={handleClick}
      >
        {titleContent}

        <ChevronDownIcon className={styles.icon} />
      </button>

      {isExpanded && (
        <div className={styles.content} data-test-id={`${dataTestId}-content`}>
          {children}
        </div>
      )}
    </div>
  );
};
